module.exports = {"222401001":"进学街道","222401002":"北山街道","222401003":"新兴街道","222401004":"公园街道","222401005":"河南街道","222401006":"建工街道","222401100":"小营镇","222401101":"依兰镇","222401102":"三道湾镇","222401105":"朝阳川镇","222401400":"延吉市林业局","222401401":"东山农场","222401402":"延边原种场","222401404":"延边新兴工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222401.json
// module id = 607
// module chunks = 0